import { createQueryHook } from '~/shared/providers/api/createQueryHook';

export type AccountAddress = {
  id: string;
  name?: string;
  streetAddress: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
  addressType: string;
  isMailingAddress: boolean;
  account: {
    id: string;
    type: string;
    name: string;
  };
};

export const useAccountAddressesQuery = createQueryHook(
  'transportation.accountAddresses',
  (params: { searchTerm?: string; offset?: number; limit?: number }) => ({
    accountAddresses: {
      __args: {
        filter: {
          searchTerm: params.searchTerm ?? '',
          searchByAccountName: true,
        },
        pagination: {
          offset: params.offset ?? 0,
          limit: params.limit ?? 100,
        },
      },
      entries: {
        id: true,
        name: true,
        address: {
          __scalar: true,
        },
        account: {
          id: true,
          type: true,
          name: true,
        },
      },
    },
  }),
  {
    select: (data): { addresses: AccountAddress[] } => ({
      addresses:
        data?.accountAddresses.entries.map((entry) => ({
          id: entry.id,
          name: entry.name ?? undefined,
          ...entry.address,
          account: {
            id: entry.account.id,
            type: entry.account.type,
            name: entry.account.name,
          },
        })) ?? [],
    }),
  },
);
